module.exports = __webpack_public_path__ + "static/media/NN-Menu.82e5141e.png";